module.exports = __webpack_public_path__ + "img/9890866.jpg";